import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileHandle } from '../../../dragDrop.directive';
import { ToasterService } from 'angular2-toaster';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';

@Component({
  selector: 'app-onboarding-tutorial',
  templateUrl: './onboarding-tutorial.component.html',
  styleUrls: ['./onboarding-tutorial.component.css'],
  // animations: [
  //   trigger('openClose', [
  //     // ...
  //     state('open', style({
  //       height: '200px',
  //       opacity: 1,
  //       backgroundColor: 'yellow'
  //     })),
  //     state('closed', style({
  //       height: '100px',
  //       opacity: 0.8,
  //       backgroundColor: 'blue'
  //     })),
  //     transition('open => closed', [
  //       animate('1s')
  //     ]),
  //     transition('closed => open', [
  //       animate('0.5s')
  //     ]),
  //   ]),
  // ],
})
export class OnboardingTutorialComponent implements OnInit {
  editorContent: any;
  @ViewChild('editor') editor;
  editdetails: boolean = false;
  isLoader: boolean;
  details: any;
  category: any;
  constructor(private apiService: ApiService, private toasterService: ToasterService, private route: ActivatedRoute, private router: Router) {
  }


  title: any;
  moduleDescription: any;
  fileToUpload: File;
  fileName: string;
  moduledetails: any = '';
  ngOnInit(): void {
    // this.isLoader = false;
    this.moduledetails = this.route.params['_value'];
    console.log( this.moduledetails)
    if (this.moduledetails.title === undefined) {
      this.editdetails = true;
    } else {
      this.moduleDescription = this.moduledetails.description;
      this.title=this.moduledetails.title;
      this.category=this.moduledetails.type;
    }
     
  }

  // for text-editor

  formatText(command) {
    document.execCommand(command, false, null);
  }
  descriptionsteps: string = "";

  setStyle(style: string) {
    let bool = document.execCommand(style, false, null);
  }

  onChange() {

  this.details = this.editor.nativeElement["innerHTML"];

  }
  executeCommand(command: string) {
    document.execCommand(command, false, '');
    this.highlightEditorButtons();
  }

  keydown() {
    this.highlightEditorButtons();
  }

  highlightEditorButtons() {
    const isBold = document.queryCommandValue("bold");
    const isItalic = document.queryCommandValue("italic");
    const isUnderline = document.queryCommandValue("underline");

    const btnBold = document.getElementById('btnBold');
    const btnItalic = document.getElementById('btnItalic');
    const btnUnderline = document.getElementById('btnUnderline');

    if (isBold === 'true') {
      btnBold.style.backgroundColor = "gray";
    } else {
      btnBold.style.backgroundColor = "lightgray";
    }

    if (isItalic === 'true') {
      btnItalic.style.backgroundColor = "gray";
    } else {
      btnItalic.style.backgroundColor = "lightgray";
    }

    if (isUnderline === 'true') {
      btnUnderline.style.backgroundColor = "gray";
    } else {
      btnUnderline.style.backgroundColor = "lightgray";
    }
  }

  // for drop upload image
  files: FileHandle[] = [];

  filesDropped(files: FileHandle[]): void {
    this.files = files;
    var form = new FormData;
    form.append('files', this.files[0].file)
    this.apiService.uploadImageArray(form).subscribe((res: any) => {
      this.isLoader = false;
      // this.Images = JSON.parse(res._body).data;
      this.Images = res.data;
      this.Thumbnail = this.Images[0].thumbnail;

      this.toasterService.pop('Success',res.message);
    },error => {
      this.toasterService.pop('error',error)
    });
  }

  getcategory(event) {
    this.category = event.target.value;
  }

  //for video upload
  videolink: any;
  videodata: any;
  videothumbnail: any;
  videofile(files: FileList) {
    this.isLoader = true;
    this.fileToUpload = files.item(0);
    var form = new FormData;
    form.append('files', this.fileToUpload)
    this.apiService.uploadImageArray(form).subscribe((res: any) => {
      this.isLoader=false;
      // this.videodata = JSON.parse(res._body).data;
      this.videodata = res.data;
      this.videolink = this.videodata[0].original;
      this.videothumbnail = this.videodata[0].thumbnail
      const message = res.message
      this.toasterService.pop('success',message)
     
    },error => {
      this.toasterService.pop('error')
    });
   
  }

  //for upload image
  Images: any;
  Thumbnail: any;
  handleFileInput(files: FileList) {
    this.isLoader = true;
    this.fileToUpload = files.item(0);
    var form = new FormData;
    form.append('files', this.fileToUpload)
    this.apiService.uploadImageArray(form).subscribe((res: any) => {
      this.isLoader = false;
      // this.Images = JSON.parse(res._body).data;
      this.Images = res.data
      this.Thumbnail = this.Images[0].thumbnail;

      this.toasterService.pop('Success',res.message);
    },error => {
      this.toasterService.pop('error',error)
    });
  }

  Addvideos() {
    this.isLoader = true;
    let data = {
      title: this.title,
      description: this.moduleDescription,
      detailedSteps: this.details,
      videoUrl: {
        original: this.videolink,
        thumbnail: this.videothumbnail,
      },
      thumbnail: this.Thumbnail,
      type: this.category,
      playedDuration: 0,
    }

    this.apiService.uploadVideos(data).subscribe((response: any) => {
      this.isLoader = false;
      this.title = '';
      this.moduleDescription = '';;
      this.descriptionsteps ='';
      this.fileName = '';
      this.moduledetails = '';
      this.toasterService.pop('success',JSON.parse(response._body).message)
    }, error => {
      this.isLoader = false;
      this.toasterService.popAsync('error',JSON.parse(error._body).error)
    })

  }

  updatemodule() {
    let data;
    if(this.videolink == undefined) {
      data = {
        _id: this.moduledetails._id,
        title: this.title || this.moduledetails.title,
        description: this.moduleDescription || this.moduledetails.description,
        detailedSteps: this.descriptionsteps || this.moduledetails.detailedSteps,
        thumbnail: this.Thumbnail || this.moduledetails.thumbnail,
        type: this.category || this.moduledetails.type,
      }
    } else {
      data = {
        _id: this.moduledetails._id,
        title: this.title || this.moduledetails.title,
        description: this.moduleDescription || this.moduledetails.description,
        detailedSteps: this.descriptionsteps || this.moduledetails.detailedSteps,
        videoUrl: {
          original: this.videolink,
          thumbnail: this.videothumbnail,
        },
        thumbnail: this.Thumbnail || this.moduledetails.thumbnail,
        type: this.category || this.moduledetails.type,
      }
    }
   
    this.apiService.UpdateVideo(data).subscribe((response: any) => {
      this.toasterService.pop('Success',JSON.parse(response._body).message)
      this.router.navigate(['onboarding-tutorial']);
      // this.toasterService.pop('success', JSON.parse(response._body).error, JSON.parse(response._body).message);
    },error => {
      this.toasterService.pop('error',error)
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/onboarding-tutorial/onboarding-tutorial.component.ts